import React, { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsAuthenticated,
  selectAuthLoading,
  selectHasMinimumRole,
} from '../../../../src/store/auth/authSelectors';
import { refreshSessionThunk } from '../../../../src/store/auth/authThunks';
import { AppDispatch } from '../../../../src/store';
import { UserRole } from '../../../types/UserInterface';

interface PrivateRouteProps {
  children: ReactNode;
  minimumRole?: UserRole;
  unauthorizedFallback?: ReactNode;
  unauthenticatedFallback: ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  minimumRole,
  unauthorizedFallback = <div>You do not have permission to view this page.</div>,
  unauthenticatedFallback,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const hasRole = useSelector(
    minimumRole ? selectHasMinimumRole(minimumRole) : () => true
  );

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(refreshSessionThunk());
    }
  }, [dispatch, isAuthenticated]);

  if (loading) return null;
  if (!isAuthenticated) return <>{unauthenticatedFallback}</>;
  if (!hasRole) return <>{unauthorizedFallback}</>;
  return <>{children}</>;
};